import { render, staticRenderFns } from "./OverviewStaff.vue?vue&type=template&id=08adcf0a&scoped=true&"
import script from "./OverviewStaff.vue?vue&type=script&lang=js&"
export * from "./OverviewStaff.vue?vue&type=script&lang=js&"
import style0 from "./OverviewStaff.vue?vue&type=style&index=0&id=08adcf0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08adcf0a",
  null
  
)

export default component.exports